// packages/shared/src/spaces.ts (pure helpers next to the types; owner M0-T02)
import type { ResidentId, VillagerId } from './types/ids';
import type { SpaceId } from './types/space';

const ID = '[0-9A-HJKMNP-TV-Z]{16}';
const HOUSE = new RegExp(`^house:(r_${ID}):([0-9])$`);
const VHOUSE = new RegExp(`^vhouse:(v_${ID})$`);

export function houseSpace(r: ResidentId, room: number): SpaceId { return `house:${r}:${room}`; }
export function villagerSpace(v: VillagerId): SpaceId { return `vhouse:${v}`; }
export function parseSpace(s: string):
  | { kind: 'out' } | { kind: 'shop' } | { kind: 'museum' }
  | { kind: 'room'; owner: ResidentId; room: number } | { kind: 'vroom'; villager: VillagerId } | null {
  if (s === 'out' || s === 'shop' || s === 'museum') return { kind: s };
  const h = HOUSE.exec(s);
  if (h) return { kind: 'room', owner: h[1] as ResidentId, room: Number(h[2]) };
  const v = VHOUSE.exec(s);
  if (v) return { kind: 'vroom', villager: v[1] as VillagerId };
  return null;
}
